<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-15"><a id="_idTextAnchor015"></a>Dwelling</h2>
<p class="Verse-new">Beneath </p>
<p class="Verse-main">the jagged</p>
<p class="Verse-main">flow of time</p>
<p class="Verse-main">upwelling springs</p>
<p class="Verse-main">of love</p>
<p class="Verse-main">push through </p>
<p class="Verse-main">the bitter grief</p>
<p class="Verse-main">of loss</p>
<p class="Verse-main">the broken pieces</p>
<p class="Verse-main">re-arranged </p>
<p class="Verse-main">as home.</p>
<p class="Verse-new">Beyond</p>
<p class="Verse-main">the loud invasive calls</p>
<p class="Verse-main">of honour, stuff, or work</p>
<p class="Verse-main">the stillness </p>
<p class="Verse-main">of a deeper well</p>
<p class="Verse-main">takes soundings</p>
<p class="Verse-main">searching </p>
<p class="Verse-main">for the heart’s ground</p>
<p class="Verse-main">the music</p>
<p class="Verse-main">of the silent rhythms</p>
<p class="Verse-main">the dwelling place</p>
<p class="Verse-main">of God.</p>
<p class="Verse-new">Touching base</p>
<p class="Verse-last">we’re on our way</p>
<p class="Verse-last">– that pearl! – </p>
<p class="Verse-last">and all around</p>
<p class="Verse-last">the searching eyes</p>
<p class="Verse-last">are asking </p>
<p class="Verse-last">Why? Why? Why?</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-17.vue?0b9edbf2